import {defineMessages} from 'react-intl'

export default defineMessages({
    show: {
        id: 'components.VoiceDrawer.show',
        defaultMessage: 'Show {count} selected voices',
    },
    hide: {
        id: 'components.VoiceDrawer.hide',
        defaultMessage: 'Hide voices',
    },
    startOverPrompt: {
        id: 'components.VoiceDrawer.startOverPrompt',
        defaultMessage: 'Are you sure you want to start over? All filters and selected voices will be disgarded.'
    },
    isLocallyStored: {
        id: 'components.VoiceDrawer.isLocallyStored',
        defaultMessage: "Your selection was saved to your browser. Come back  any time, to resume your selection."
    },
    downloadingByClickingBelow: {
        id: 'components.VoiceDrawer.downloadingByClickingBelow',
        defaultMessage: 'You can add as many demos as you like, before downloading by clicking below.'
    },
    callToAction: {
        id: 'components.VoiceDrawer.callToAction',
        defaultMessage: `<h1>Looking for voices in multiple languages?</h1>
            <p>Change any search filter, to find and add as many voices as you'd like. Your selected voices will stay put.</p>`
    },
    includesAllVoices: {
        id: 'components.VoiceDrawer.includesAllVoices',
        defaultMessage: "Your current selection will include all voices that matches the following filters and it will auto update in the future if new voices, that matches the filters, are added or removed."
    },
    titleHash: {
        id: 'components.VoiceDrawer.titleHash',
        defaultMessage: 'Project #{hashId}'
    },
    titleGroupBy: {
        id: 'components.VoiceDrawer.titleGroupBy',
        defaultMessage: ' Selected demos (grouped by voice)'
    },
    titleDefault: {
        id: 'components.VoiceDrawer.titleDefault',
        defaultMessage: 'Selected voices'
    },
    reset: {
        id: 'components.VoiceDrawer.reset',
        defaultMessage: 'Reset'
    },
    preparingProjectLead: {
        id: 'components.VoiceDrawer.preparingProjectLead',
        defaultMessage: `Preparing project for lead {leadId}`
    },
    preparingProjectDeal: {
        id: 'components.VoiceDrawer.preparingProjectDeal',
        defaultMessage: `Preparing project for deal {dealId}`
    },
    autoSelectionDems: {
        id: 'components.VoiceDrawer.autoSelectionDems',
        defaultMessage: `Auto selecting {categories} demos`
    },
    freeQuote: {
        id: 'components.VoiceDrawer.freeQuote',
        defaultMessage: "Get free quote"
    },
    save: {
        id: 'components.VoiceDrawer.save',
        defaultMessage: 'Saved'
    },
    saveLater: {
        id: 'components.VoiceDrawer.saveLater',
        defaultMessage: 'Save for later'
    },
    share: {
        id: 'components.VoiceDrawer.share',
        defaultMessage: 'Share'
    },
    loading: {
        id: 'components.VoiceDrawer.loading',
        defaultMessage: 'Loading'
    },
    characters: {
        id: 'components.VoiceDrawer.characters',
        defaultMessage: 'Characters:'
    },
    uspQuoteSpeed: {
        id: 'components.VoiceDrawer.uspQuoteSpeed',
        defaultMessage: 'Get Quote in 1 hour so you can move fast'
    },
    uspTransparentPrices: {
        id: 'components.VoiceDrawer.uspTransparentPrices',
        defaultMessage: 'Transparent prices - no surprises'
    },
    uspExclusivePartnerships: {
        id: 'components.VoiceDrawer.uspExclusivePartnerships',
        defaultMessage: 'Exclusive artist partnerships for the best rates'
    }
})
